import { render, staticRenderFns } from "./OrderStatusCounts.vue?vue&type=template&id=3f87cdbe&scoped=true&"
import script from "./OrderStatusCounts.vue?vue&type=script&lang=js&"
export * from "./OrderStatusCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87cdbe",
  null
  
)

export default component.exports